import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

/**
 * Wrapper de /liftlogic/app-settings/:key. Sin estado (mismo patrón que
 * useMenuItemsApi / useIncidentApi): retorna la promise del axios.
 */
const useAppSettingsApi = () => {
  const getSetting = useCallback(async (key) => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/app-settings/${key}`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const setSetting = useCallback(async (key, value) => {
    const { data } = await axios.put(
      `${API_PATH}/liftlogic/app-settings/${key}`,
      { value },
      { headers: authHeaders() }
    );
    return data;
  }, []);

  return useMemo(() => ({ getSetting, setSetting }), [getSetting, setSetting]);
};

export default useAppSettingsApi;
